import React, { FC } from 'react';
import Text from 'crehana-ui/Text';
import CheckNew from 'crehana-icons/CheckNew';
import { greenMain } from 'crehana-ui/styles/colors';
import { COURSE_DETAIL_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import { useTranslation } from 'Shared/Hooks/useTranslation';
import { Course } from '../types';

type RequirementsSectionProps = {
  course: Course;
};

const RequirementsSection: FC<RequirementsSectionProps> = ({ course }) => {
  const _requirements = course.requirements ? [...course.requirements] : [];
  const { t } = useTranslation(COURSE_DETAIL_TRANSLATION_KEY);

  let requiredSoftware = null;

  if (course.softwareDetails) {
    course.softwareDetails.forEach(softwareDetail => {
      if (softwareDetail.isPrincipal) {
        requiredSoftware = {
          image: softwareDetail.software.originalImageUrl || '',
          text: softwareDetail.software.name,
          description: softwareDetail.description,
        };
      }
    });
  }

  if (_requirements.length > 0) {
    return (
      <section className="mb-40 sm:mb-48">
        <h3 className="font-h4 mb-16 sm:mb-24">{t('REQUIREMENTS_TITLE_2')}</h3>
        <ul>
          {requiredSoftware && requiredSoftware?.image.length > 0 && (
            <li className="flex items-start mb-8 sm:mb-12">
              <div style={{ marginTop: 4 }}>
                <CheckNew
                  className="flex-shrink-0"
                  color={greenMain}
                  size={16}
                />
              </div>
              <div className="flex items-center">
                <img
                  className="w-24 h-24 mr-4 ml-8"
                  width="24"
                  height="24"
                  src={requiredSoftware.image}
                  alt="software"
                />
                <Text className="ml-4" type="body2" as="p">
                  {requiredSoftware.text}
                </Text>
                {requiredSoftware.description && (
                  <Text className="ml-4" type="body2" color="gray-dark" as="p">
                    {requiredSoftware.description}
                  </Text>
                )}
              </div>
            </li>
          )}
          {_requirements.map((el, index) => (
            <li key={`requirement-${index}`} className="flex items-start mb-8">
              <div style={{ marginTop: 4 }}>
                <CheckNew
                  className="flex-shrink-0"
                  color={greenMain}
                  size={16}
                />
              </div>
              <Text className="ml-8" type="body2" as="p">
                {el.text}
              </Text>
            </li>
          ))}
        </ul>
      </section>
    );
  }
};

export default React.memo(RequirementsSection);
